import { createAction } from '@reduxjs/toolkit';
import { TwsData } from '../../utils/types';

export const connect = createAction<string, 'SOCKET_CONNECT'>('SOCKET_CONNECT');
export const disconnect = createAction('SOCKET_DISCONNECT');
export const wsConnecting = createAction('SOCKET_CONNECTING');
export const wsOpen = createAction('SOCKET_OPEN');
export const wsClose = createAction('SOCKET_CLOSE');
export const wsMessage = createAction<TwsData, 'SOCKET_MESSAGE'>(
    'SOCKET_MESSAGE'
);
export const wsError = createAction<string, 'SOCKET_ERROR'>('SOCKET_ERROR');

export type TSocketActions =
    | ReturnType<typeof connect>
    | ReturnType<typeof disconnect>
    | ReturnType<typeof wsConnecting>
    | ReturnType<typeof wsOpen>
    | ReturnType<typeof wsClose>
    | ReturnType<typeof wsMessage>
    | ReturnType<typeof wsError>;
